export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5143.77c2cb66.jpg";